var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreApple = function SvgStoreApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D252D",
    d: "M26.18 19.153a5.24 5.24 0 0 1 2.473-4.367c-.947-1.374-2.504-2.198-4.183-2.26-1.771-.183-3.481 1.07-4.367 1.07-.916 0-2.29-1.039-3.786-1.008a5.6 5.6 0 0 0-4.703 2.87C9.6 18.97 11.095 24.13 13.05 26.97c.978 1.405 2.107 2.931 3.604 2.9 1.465-.06 1.984-.915 3.755-.915 1.74 0 2.26.916 3.756.885 1.558-.03 2.535-1.404 3.481-2.809a10.7 10.7 0 0 0 1.588-3.237 5.04 5.04 0 0 1-3.053-4.641M23.308 10.664A5 5 0 0 0 24.468 7a5.1 5.1 0 0 0-3.359 1.74 4.82 4.82 0 0 0-1.19 3.543c1.313 0 2.564-.58 3.389-1.619"
  })));
};
export default SvgStoreApple;